export default class RequestParam {
  constructor(url, params) {
    this._url = url
    this._params = params
  }

  set headers(value) {
    this.headers = value
  }

  get headers() {
    return this.headers
  }

  get url() {
    return this._url
  }

  set url(value) {
    return (this._url = value)
  }

  get params() {
    return this._params
  }

  set params(value) {
    return (this._params = value)
  }

  getParamsStr() {
    return JSON.stringify(this.params)
  }
}



// WEBPACK FOOTER //
// ./src/js/RequestParam.js